import { api } from '../api/client';
import type { ContentItem } from '../api/bindings/ContentItem';
import type { SignalAction } from '../api/bindings/SignalAction';

interface Props {
  item: ContentItem;
  onSignal: (action: SignalAction) => void;
}

export function FeedItem({ item, onSignal }: Props) {
  const image = item.media.find((m) => m.kind.startsWith('image'))?.url;
  const published = item.published_at ? new Date(item.published_at).toLocaleDateString() : null;

  const openAndClick = () => {
    onSignal('click');
    // Fire-and-forget signal; navigation proceeds regardless.
    void api.signal({ item_id: item.id, action: 'click' }).catch(() => {});
  };

  return (
    <article className="feed-item card">
      {image && (
        <a href={item.url ?? '#'} target="_blank" rel="noreferrer" onClick={openAndClick} className="feed-thumb">
          <img src={image} alt="" loading="lazy" />
        </a>
      )}
      <div className="feed-body">
        <div className="feed-meta">
          <span className="score" title="Your ranking score">
            {item.score.toFixed(2)}
          </span>
          {item.author && <span className="muted">{item.author}</span>}
          {published && <span className="muted">{published}</span>}
        </div>
        <h2 className="feed-title">
          {item.url ? (
            <a href={item.url} target="_blank" rel="noreferrer" onClick={openAndClick}>
              {item.title}
            </a>
          ) : (
            item.title
          )}
        </h2>
        {item.summary && <p className="feed-summary">{item.summary}</p>}
        {item.tags.length > 0 && (
          <div className="tags">
            {item.tags.map((t) => (
              <span key={t} className="tag">
                {t}
              </span>
            ))}
          </div>
        )}
        <div className="feed-actions">
          <button onClick={() => onSignal('save')} disabled={item.state === 'saved'}>
            {item.state === 'saved' ? '★ Saved' : '☆ Save'}
          </button>
          <button onClick={() => onSignal('dismiss')} className="ghost">
            ✕ Dismiss
          </button>
        </div>
      </div>
    </article>
  );
}
